import React, { useState, useCallback } from "react";
import "./AvisosAutomaticos.scss";
import CardView from "../../components/molecules/CardView/CardView";
import Button from "../../components/atoms/Button/Button";
import { toast, Toaster } from "sonner";

// Opciones de envío disponibles
const SEND_OPTIONS = [
    { id: "email", name: "Correo electrónico", icon: "📧" },
    { id: "whatsapp", name: "WhatsApp", icon: "💬" },
    { id: "sms", name: "SMS", icon: "📱" },
];

const AvisosAutomaticos = () => {
    const [message, setMessage] = useState("");
    const [selectedOption, setSelectedOption] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    // Manejador de cambio del mensaje
    const handleMessageChange = useCallback((e) => {
        setMessage(e.target.value);
    }, []);

    // Manejador de cambio de opción
    const handleOptionChange = useCallback((e) => {
        setSelectedOption(e.target.value);
    }, []);

    // Manejador de envío
    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validación
        if (!message.trim()) {
            toast.error("Validación fallida", {
                description: "Por favor, escribe un mensaje.",
                position: "top-right",
                duration: 4000,
            });
            return;
        }

        if (!selectedOption) {
            toast.error("Validación fallida", {
                description: "Por favor, selecciona un método de envío.",
                position: "top-right",
                duration: 4000,
            });
            return;
        }

        setIsLoading(true);
        const toastId = toast.loading("Enviando aviso...", {
            position: "top-right",
        });

        try {
            // Simular envío (reemplazar con servicio real)
            await new Promise((resolve) => setTimeout(resolve, 2000));

            toast.success("¡Éxito!", {
                description: `Aviso enviado por ${
                    SEND_OPTIONS.find((opt) => opt.id === selectedOption)?.name
                }`,
                position: "top-right",
                duration: 5000,
                icon: "🎉",
                id: toastId,
            });

            // Limpiar formulario
            setMessage("");
            setSelectedOption("");
        } catch (error) {
            console.error("Error al enviar aviso:", error);
            toast.error("Error crítico", {
                description:
                    "Ocurrió un error al enviar el aviso. Por favor intenta nuevamente.",
                position: "top-right",
                duration: 5000,
                id: toastId,
            });
        } finally {
            setIsLoading(false);
        }
    };

    // Manejador de limpieza
    const handleClear = useCallback(() => {
        setMessage("");
        setSelectedOption("");
        toast.info("Formulario limpiado", {
            position: "top-right",
            duration: 3000,
        });
    }, []);

    return (
        <CardView>
            <div className="avisos-automaticos">
                <div className="avisos-automaticos__container">
                    <form
                        className="avisos-automaticos__card"
                        onSubmit={handleSubmit}
                    >
                        <div className="avisos-automaticos__header">
                            <h2 className="avisos-automaticos__title">
                                ENVIAR AVISO AUTOMÁTICO
                            </h2>
                        </div>

                        <div className="avisos-automaticos__content">
                            <div className="avisos-automaticos__field">
                                <label
                                    htmlFor="message"
                                    className="avisos-automaticos__label"
                                >
                                    Escribe tu mensaje *
                                </label>
                                <textarea
                                    id="message"
                                    name="message"
                                    value={message}
                                    onChange={handleMessageChange}
                                    placeholder="Escribe el mensaje que deseas enviar a tus clientes..."
                                    className="avisos-automaticos__textarea"
                                    rows={6}
                                />
                            </div>

                            <div className="avisos-automaticos__field">
                                <label className="avisos-automaticos__label">
                                    Selecciona el método de envío *
                                </label>
                                <div className="avisos-automaticos__options">
                                    {SEND_OPTIONS.map((option) => (
                                        <label
                                            key={option.id}
                                            className={`avisos-automaticos__option ${
                                                selectedOption === option.id
                                                    ? "avisos-automaticos__option--selected"
                                                    : ""
                                            }`}
                                        >
                                            <input
                                                type="radio"
                                                name="sendOption"
                                                value={option.id}
                                                checked={
                                                    selectedOption === option.id
                                                }
                                                onChange={handleOptionChange}
                                                className="avisos-automaticos__radio"
                                            />
                                            <span className="avisos-automaticos__option-icon">
                                                {option.icon}
                                            </span>
                                            <span className="avisos-automaticos__option-text">
                                                {option.name}
                                            </span>
                                        </label>
                                    ))}
                                </div>
                            </div>

                            <div className="avisos-automaticos__actions">
                                <Button
                                    text="LIMPIAR"
                                    type="button"
                                    onClick={handleClear}
                                    className="avisos-automaticos__button avisos-automaticos__button--cancel"
                                    disabled={isLoading}
                                />
                                <Button
                                    text={isLoading ? "ENVIANDO..." : "ENVIAR"}
                                    type="submit"
                                    className="degrad avisos-automaticos__button avisos-automaticos__button--submit"
                                    disabled={isLoading}
                                />
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <Toaster />
        </CardView>
    );
};

export default AvisosAutomaticos;
